import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { formatApiErrorDetail } from "../../lib/api";

export default function AdminLogin() {
  const { user, login, checking } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("letsdosomework@gmail.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!checking && user) nav("/admin/dashboard");
  }, [user, checking, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#030712] px-4" data-testid="admin-login-page">
      <div className="absolute inset-0 grid-lines opacity-30" />
      <div className="absolute inset-0 hero-radial" />
      <div className="relative w-full max-w-md">
        <div className="flex items-center justify-center mb-8">
          <img src="/logo.png" alt="SRAM & MRAM" className="h-16 w-auto" />
        </div>
        <div className="card-vertical rounded-2xl p-8 emerald-glow">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="w-5 h-5 text-emerald-400" />
            <h1 className="text-xl font-display font-bold text-white">Admin Login</h1>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="text-sm text-slate-400 mb-1.5 block">Email</label>
              <input data-testid="admin-username-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-[#070b12] border border-slate-800 rounded-lg px-4 py-3 text-slate-200 focus:outline-none focus:border-emerald-500/50" />
            </div>
            <div>
              <label className="text-sm text-slate-400 mb-1.5 block">Password</label>
              <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-[#070b12] border border-slate-800 rounded-lg px-4 py-3 text-slate-200 focus:outline-none focus:border-emerald-500/50" />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-btn"
              className="btn-emerald w-full py-3 rounded-lg disabled:opacity-60">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
        <p className="text-center text-slate-600 text-xs mt-6 font-mono">Authorized personnel only</p>
      </div>
    </div>
  );
}
